module.exports = __webpack_public_path__ + "static/event-x-live-280ea245c91a0da7dbceccb4401fb157.jpg";